<template lang="pug">
.wrapper(v-if='ativarJanela')
    .bloco(:class='alterarPosicaoBloco')
        .bloco-head(@click='minimizarBloco = !minimizarBloco')
            h2 {{$t('mensagens.laudos.renovabio.tituloModalAsync')}}
            div
                i.mdi.bloco-icon.mdi-chevron-right(
                    :class='minimizarBloco ? "mdi-window-minimize" : "mdi-window-maximize"'
                )
                i.icone-fechar.mdi.mdi-close(
                    v-if='minimizarBloco'
                    @click='handleFecharModal'
                )

        transition(name='slide')
            .bloco-body(v-if='minimizarBloco')
                .em-andamento
                    p {{ $t('mensagens.laudos.renovabio.emAndamento') }}
                    span.link-button(@click='abrirModalCancelarTransferencias') {{ $t('mensagens.operacao.acoes.cancelar') }}
                .col
                    .row.download-lista(v-if='listaDownlod.length > 0')
                        p Download
                    .row.corpo-mensagem-download(@mouseover='controlarEventoMouseOver(true, index, listaDownlod)', @mouseleave='controlarEventoMouseOver(false, index, listaDownlod)', v-for='(value, index) in listaDownlod', :key='index')
                        i.icone.lyra-download
                        p.nome-arquivo-download {{ value.arquivo }}
                        .lista-espera(v-if='value.step === steps.naFila && !value.cancelarNaFila') {{ $t('mensagens.laudos.renovabio.naFila') }}
                        i.icone-remover.lyra-lixeira(@click='cancelarTransferenciaNaFila(index, listaDownlod)', v-if='value.step === steps.naFila && value.cancelarNaFila')
                        i.icone.lyra-loading(v-if='value.step === steps.processamento')
                        i.icone-status-sucesso.mdi.mdi-check-circle(v-if='value.step === steps.processouOK')
                        i.icone-status-falha.mdi.mdi-close-circle(v-if='value.step === steps.erroProcessamento')

                .col(style='margin-top: 16px')
                    .row.download-lista(v-if='listaUpload.length > 0')
                        p Upload
                    .row.corpo-mensagem-download(@mouseover='controlarEventoMouseOver(true, index, listaUpload)', @mouseleave='controlarEventoMouseOver(false, index, listaUpload)', v-for='(value, index) in listaUpload', :key='index')
                        i.icone.lyra-upload
                        p.nome-arquivo-upload {{ value.arquivo }}
                        .lista-espera(v-if='value.step === steps.naFila && !cancelarNaFila') {{ $t('mensagens.laudos.renovabio.naFila') }}
                        i.icone-remover.lyra-lixeira(@click='cancelarTransferenciaNaFila(index, listaUpload)', v-if='value.step === steps.naFila && value.cancelarNaFila')
                        i.icone.lyra-loading(v-if='value.step === steps.processamento')
                        i.icone-status-sucesso.mdi.mdi-check-circle(v-if='value.step === steps.processouOK')
                        i.icone-status-falha.mdi.mdi-close-circle(v-if='value.step === steps.erroProcessamento')

                modal-cancelamento-assincronos(
                        :abrirModalCancelar='abrirModalCancelar',
                        @limpar-fila-espera='limparFilaEspera',
                        @fechar-modal-cancelar='fecharModalCancelarTransferencias'
                    )
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import store from '@/store';
import ModalCancelamentoAssincronos from '@/components/laudos/renovabio/ModalCancelamentoAssincronos.vue';
import {retryOperation} from '@/utils/retry-operation';
import {connect, disconnect, forcedDisconnect, subscribe} from '@/utils/websocket';
import LaudosService from '@/services/LaudosService';
import utilsService from '@/services/UtilsService';
import TipoLaudo from '@/constants/TipoLaudo';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import keycloakUtil from '@/utils/keycloak';

export default {
    name: 'ModalDocumentosAssincronos',

    components: {
        ModalCancelamentoAssincronos
    },

    data() {
        return {
            cancelarNaFila: false,
            abrirModalCancelar: false,
            minimizarBloco: true,
            ativarJanela: false,
            steps: {
                listagem: 'listagem',
                naFila: 'naFila',
                processamento: 'processamento',
                processouOK: 'processouOK',
                erroProcessamento: 'erroProcessamento'
            },
            codigoRenovaBio: 'RENOVABIO',
            codigoMonitoramentoAgricola: 'AGRICOLA',
            listaDownlod: [],
            listaUpload: []
        };
    },

    computed: {
        ...mapGetters([
            'emProcessamentoUploadLoteRenovabio',
            'uploadLoteRenovabioConcluido',
            'hashPlanilhaRenovabio',
            'emProcessamentoDownloadLoteRenovabio',
            'emProcessamentoDownloadMonitoramentoAgricola',
            'laudosSelecionadosDownloadLoteRenovabio',
            'marcarExportarNeowayPDF',
            'marcarExportarPDF',
            'usuarioLogado'
        ]),
        alterarPosicaoBloco() {
            const alterarPosicaoBloco =
                this.emProcessamentoUploadLoteRenovabio &&
                this.marcarExportarNeowayPDF.length > 0 &&
                this.marcarExportarPDF.length > 0;
            return alterarPosicaoBloco ? 'blocos-ativos' : '';
        }
    },

    watch: {
        emProcessamentoUploadLoteRenovabio: {
            handler(newValue) {
                if (newValue) {
                    this.ativarJanela = true;
                    this.minimizarBloco = true;
                    this.inserirUploadNaLista(this.$t('mensagens.laudos.renovabio.textoModalAsyncStep1'), this.codigoRenovaBio);
                    this.gerenciarFilaDeUpload();
                }
            },
            immediate: true
        },

        emProcessamentoDownloadLoteRenovabio: {
            handler(newValue) {
                if (newValue) {
                    this.ativarJanela = true;
                    this.minimizarBloco = true;
                    this.inserirDownloadNaLista(this.$t('mensagens.laudos.renovabio.textoModalAsyncStep1'), this.codigoRenovaBio);
                    this.gerenciarFilaDeDownload();
                }
            },
            immediate: true
        },
        emProcessamentoDownloadMonitoramentoAgricola: {
            handler(newValue) {
                if (newValue) {
                    this.ativarJanela = true;
                    this.minimizarBloco = true;
                    const data = this.formatDateForFilename(new Date());
                    const base = this.traduzirNomeArquivo('mensagens.laudos.nomeArquivoMonitoramentoAgricola', 'monitoramento_agricola');
                    const nomeDoArquivo = `${base}_${data}.xlsx`;
                    this.inserirDownloadNaLista(nomeDoArquivo, this.codigoMonitoramentoAgricola);
                    this.gerenciarFilaDeDownload();
                }
            },
            immediate: true
        }
    },

    methods: {
        ...mapActions([
            'setEmProcessamentoUploadLoteRenovabio',
            'clearUploadLoteRenovabioConcluido',
            'clearEmProcessamentoUploadLoteRenovabio',
            'setEmProcessamentoDownloadLoteRenovabio',
            'clearEmProcessamentoDownloadLoteRenovabio',
            'clearEmProcessamentoDownloadMonitoramentoAgricola'
        ]),
        isTokenValido() {
            let keycloak = keycloakUtil.getKeycloakInstance();
            let dezMinutos = 600;
            if (keycloak.isTokenExpired(dezMinutos)) {
                this.atualizarTokenAcesso(keycloak);
            }
        },
        async atualizarTokenAcesso(keycloak) {
            let dezMinutos = 600;
            await keycloak.updateToken(dezMinutos).then((tokenAtualizado) => {
                if (tokenAtualizado) {
                    sessionStorage.setItem('jwtToken', keycloak.token);
                    sessionStorage.setItem('refreshToken', keycloak.refreshToken);
                    this.gerenciarTransferenciaWebsocket(this.listaDownlod);
                    this.gerenciarTransferenciaWebsocket(this.listaUpload);
                }
            });
        },
        controlarEventoMouseOver(hover, index, lista) {
            let value = lista[index];
            if (value.step === this.steps.naFila) {
                value.cancelarNaFila = hover;
                this.$set(lista, index, value);
            }
        },
        cancelarTransferenciaNaFila(index, lista) {
            let value = lista[index];
            if (value.codigo === this.codigoRenovaBio) {
                this.clearEmProcessamentoUploadLoteRenovabio();
                this.clearEmProcessamentoDownloadLoteRenovabio();
            }
            if (value.codigo === this.codigoMonitoramentoAgricola) {
                this.clearEmProcessamentoDownloadMonitoramentoAgricola();
            }
            lista.splice(index, 1);
        },
        async limparFilaEspera() {
            this.fecharModalCancelarTransferencias();
            await this.cancelarTodasTransferenciaNaFila(this.listaDownlod);
            await this.cancelarTodasTransferenciaNaFila(this.listaUpload);
        },
        cancelarTodasTransferenciaNaFila(lista) {
            let indexNaFila = this.encontrarIndexLista(this.steps.naFila, lista);
            while (indexNaFila >= 0) {
                this.cancelarTransferenciaNaFila(indexNaFila, lista);
                indexNaFila = this.encontrarIndexLista(this.steps.naFila, lista);
            }
        },
        fecharModalCancelarTransferencias() {
            this.abrirModalCancelar = false;
        },
        abrirModalCancelarTransferencias() {
            this.abrirModalCancelar = true;
        },
        loopingTimeout() {
            this.timeoutEvitarLogOff = setInterval(() => {
                this.isTokenValido();
                this.enviarPingWebsocket();
            }, 120000);
        },
        async enviarPingWebsocket() {
            await this.receberPongWebsocket();
            await utilsService.enviarPingWebsocket();
        },
        async receberPongWebsocket() {
            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/ws/pong`,
                    response => {
                        if (!response) {
                            this.gerenciarTransferenciaWebsocket(this.listaDownlod);
                            this.gerenciarTransferenciaWebsocket(this.listaUpload);
                        }
                    });
            } catch (error) {
                await this.gerenciarTransferenciaWebsocket(this.listaDownlod);
                await this.gerenciarTransferenciaWebsocket(this.listaUpload);
            }
        },
        subscribeUploadLoteRenovabio() {
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/laudo/processamento-planilha`,
                response => {
                    if (response) {
                        clearInterval(this.timeoutEvitarLogOff);
                        this.terminouProcessamentoUpload();
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.laudos.renovabio.laudosEmLoteProcessadosComSucesso'
                            )
                        });
                        let index = this.encontrarIndexLista(this.steps.processamento, this.listaUpload);
                        let upload = {
                            ...this.listaUpload[index],
                            step: this.steps.processouOK,
                            arquivo: this.$t('mensagens.laudos.renovabio.textoModalAsyncStep2')
                        };
                        this.$set(this.listaUpload, index, upload);
                    } else {
                        clearInterval(this.timeoutEvitarLogOff);
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.operacao.notificacao.solicitacaoErro'
                            )
                        });
                        let index = this.encontrarIndexLista(this.steps.processamento, this.listaUpload);
                        let upload = {
                            ...this.listaUpload[index],
                            step: this.steps.erroProcessamento,
                            arquivo: this.$t('mensagens.laudos.renovabio.textoModalAsyncStep4')
                        };
                        this.$set(this.listaUpload, index, upload);
                    }
                    store.dispatch('setUploadLoteRenovabioConcluido', true);
                    this.clearEmProcessamentoUploadLoteRenovabio();
                    disconnect();
                    this.gerenciarFilaDeUpload();
                }
            );
        },
        async handleUploadLoteRenovabio() {
            this.clearUploadLoteRenovabioConcluido();
            let params = this.hashPlanilhaRenovabio;

            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.apiOff')
                });
                return;
            }
            if (this.usuarioLogado) {
                this.loopingTimeout();

                try {
                    this.subscribeUploadLoteRenovabio();
                    await retryOperation(
                        LaudosService.processarPlaninlha,
                        params,
                        5000,
                        10
                    );
                } catch (error) {
                    clearInterval(this.timeoutEvitarLogOff);
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.operacao.notificacao.solicitacaoErro'
                        )
                    });
                    let index = this.encontrarIndexLista(this.steps.processamento, this.listaUpload);
                    let upload = {
                        ...this.listaUpload[index],
                        step: this.steps.erroProcessamento,
                        arquivo: this.$t('mensagens.laudos.renovabio.textoModalAsyncStep4')
                    };
                    this.$set(this.listaUpload, index, upload);
                    this.gerenciarFilaDeUpload();
                }
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.usuarioDeslogado'
                    )
                });
                clearInterval(this.timeoutEvitarLogOff);
                disconnect();
            }
        },
        async gerenciarFilaDeDownload() {
            this.isTokenValido();
            let indexEmProcessamento = this.encontrarIndexLista(this.steps.processamento, this.listaDownlod);
            if (indexEmProcessamento >= 0) {
                return;
            }
            let indexNaFila = this.encontrarIndexLista(this.steps.naFila, this.listaDownlod);
            if (indexEmProcessamento < 0 && indexNaFila >= 0) {
                let download = {
                    ...this.listaDownlod[indexNaFila],
                    step: this.steps.processamento
                };
                this.$set(this.listaDownlod, indexNaFila, download);
                if (download.codigo === this.codigoRenovaBio) {
                    await this.handleDownloadLoteRenovabio();
                } else if (download.codigo === this.codigoMonitoramentoAgricola) {
                    await MonitoramentoAgricolaService.buscarPlanilhaMonitoramentoAgricola();
                    await this.handleDownloadMonitoramentoAgricola();
                }
            }
        },
        async gerenciarTransferenciaWebsocket(lista) {
            let indexEmProcessamento = this.encontrarIndexLista(this.steps.processamento, lista);
            if (indexEmProcessamento < 0) {
                return;
            }
            try {
                await forcedDisconnect();
                await connect();
            } catch {
                this.$notify.error({
                    message:
                        this.$t('mensagens.operacao.notificacao.erroApiPlanilha')
                });
                return;
            }
            let download = lista[indexEmProcessamento];
            if (download.codigo === this.codigoRenovaBio) {
                this.subscribeDownloadLoteRenovabio();
            } else if (download.codigo === this.codigoMonitoramentoAgricola) {
                this.subscribeDownloadMonitoramentoAgricola();
            }
        },
        gerenciarFilaDeUpload() {
            let indexEmProcessamento = this.encontrarIndexLista(this.steps.processamento, this.listaUpload);
            if (indexEmProcessamento >= 0) {
                return;
            }
            let indexNaFila = this.encontrarIndexLista(this.steps.naFila, this.listaUpload);
            if (indexEmProcessamento < 0 && indexNaFila >= 0) {
                let upload = {
                    ...this.listaUpload[indexNaFila],
                    step: this.steps.processamento
                };
                this.$set(this.listaUpload, indexNaFila, upload);
                if (upload.codigo === this.codigoRenovaBio) {
                    this.handleUploadLoteRenovabio();
                }
            }
        },
        subscribeDownloadMonitoramentoAgricola() {
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/exportar/planilha/agricola`,
                response => {
                    if (response) {
                        let index = this.encontrarIndexLista(this.steps.processamento, this.listaDownlod);
                        let download = {
                            ...this.listaDownlod[index],
                            step: this.steps.processouOK
                        };
                        const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response}`;
                        const link = document.createElement('a');
                        link.href = linkSource;
                        link.download = download.arquivo;
                        link.click();
                        link.remove();
                        this.$set(this.listaDownlod, index, download);
                        this.terminouDownloadPlanilhaAgricola();
                    } else {
                        clearInterval(this.timeoutEvitarLogOff);
                        this.$notify.error({
                            message: this.$t('mensagens.operacao.notificacao.erroExportarPlanilha')
                        });
                        let index = this.encontrarIndexLista(this.steps.processamento, this.listaDownlod);
                        let download = {
                            ...this.listaDownlod[index],
                            step: this.steps.erroProcessamento
                        };
                        this.$set(this.listaDownlod, index, download);
                    }
                    this.clearEmProcessamentoDownloadMonitoramentoAgricola();
                    disconnect();
                    this.gerenciarFilaDeDownload();
                }
            );
        },
        async handleDownloadMonitoramentoAgricola() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message:
                        this.$t('mensagens.operacao.notificacao.erroApiPlanilha')
                });
                return;
            }
            if (this.usuarioLogado) {
                this.loopingTimeout();
                try {
                    this.subscribeDownloadMonitoramentoAgricola();
                } catch (error) {
                    clearInterval(this.timeoutEvitarLogOff);
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroExportarPlanilha')
                    });
                    let index = this.encontrarIndexLista(this.steps.processamento, this.listaDownlod);
                    let download = {
                        ...this.listaDownlod[index],
                        step: this.steps.erroProcessamento
                    };
                    this.$set(this.listaDownlod, index, download);
                    this.gerenciarFilaDeDownload();
                }
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.usuarioDeslogado'
                    )
                });
                clearInterval(this.timeoutEvitarLogOff);
                disconnect();
            }
        },
        subscribeDownloadLoteRenovabio() {
            let downloadResultadoParte1 = '';
            let downloadResultadoParte2 = '';
            let downloadResultadoParte3 = '';
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/laudo/download-resultado-parte-1`,
                response => {
                    downloadResultadoParte1 = response;
                });
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/laudo/download-resultado-parte-2`,
                response => {
                    downloadResultadoParte2 = response;
                });
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/laudo/download-resultado-parte-3`,
                response => {
                    downloadResultadoParte3 = response;
                });
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/laudo/download-resultado-parte-4`,
                response => {
                    if (response) {
                        const linkSource = `data:application/zip;base64,${downloadResultadoParte1 + downloadResultadoParte2 + downloadResultadoParte3 + response}`;
                        const link =
                            document.createElement('a');
                        const data = this.formatDateForFilename(new Date());
                        const base = this.traduzirNomeArquivo('mensagens.laudos.renovabio.nomeArquivo', 'Laudos_renovabio');
                        const fileName = `${base}_${data}.zip`;
                        link.href = linkSource;
                        link.download = fileName;
                        document.body.append(link);
                        link.click();
                        link.remove();
                        clearInterval(this.timeoutEvitarLogOff);
                        let index = this.encontrarIndexLista(this.steps.processamento, this.listaDownlod);
                        let download = {
                            ...this.listaDownlod[index],
                            step: this.steps.processouOK,
                            arquivo: this.$t('mensagens.laudos.renovabio.textoModalAsyncStep2')
                        };
                        this.$set(this.listaDownlod, index, download);
                        this.terminouProcessamentoDownload();
                    } else {
                        clearInterval(this.timeoutEvitarLogOff);
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.laudos.renovabio.errorMessageDownloadLote'
                            )
                        });
                        let index = this.encontrarIndexLista(this.steps.processamento, this.listaDownlod);
                        let download = {
                            ...this.listaDownlod[index],
                            step: this.steps.erroProcessamento,
                            arquivo: this.$t('mensagens.laudos.renovabio.textoModalAsyncStep4')
                        };
                        this.$set(this.listaDownlod, index, download);
                    }
                    this.clearEmProcessamentoDownloadLoteRenovabio();
                    disconnect();
                    this.gerenciarFilaDeDownload();
                }
            );
        },
        async handleDownloadLoteRenovabio() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.apiOff'
                    )
                });
                return;
            }
            if (this.usuarioLogado) {
                let filtrosDownloadEmLote = this.laudosSelecionadosDownloadLoteRenovabio.filtros;
                let filtros = {
                    filtrosDownloadEmLote,
                    situacaoId: 2,
                    tipoLaudoId: TipoLaudo.RENOVABIO
                };
                let params = filtros;

                this.loopingTimeout();

                try {
                    this.subscribeDownloadLoteRenovabio();
                    await retryOperation(
                        LaudosService.processarDownloadTodosLaudosProcessadosRenovabios,
                        params,
                        5000,
                        10
                    );
                } catch (error) {
                    clearInterval(this.timeoutEvitarLogOff);
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.laudos.renovabio.errorMessageDownloadLote'
                        )
                    });
                    let index = this.encontrarIndexLista(this.steps.processamento, this.listaDownlod);
                    let download = {
                        ...this.listaDownlod[index],
                        step: this.steps.erroProcessamento,
                        arquivo: this.$t('mensagens.laudos.renovabio.textoModalAsyncStep4')
                    };
                    this.$set(this.listaDownlod, index, download);
                    await this.gerenciarFilaDeDownload();
                }
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.usuarioDeslogado'
                    )
                });
                clearInterval(this.timeoutEvitarLogOff);
                disconnect();
            }
        },

        terminouProcessamentoUpload() {
            this.ativarJanela = true;
            this.minimizarBloco = true;
            this.clearEmProcessamentoUploadLoteRenovabio();
            store.dispatch('setHashPlanilhaRenovabio', null);
            disconnect();
        },

        terminouProcessamentoDownload() {
            this.ativarJanela = true;
            this.minimizarBloco = true;
            this.clearEmProcessamentoDownloadLoteRenovabio();
            store.dispatch('setLaudosSelecionadosDownloadLoteRenovabio', null);
            store.dispatch('setLimparSelecaoLoteRenovabio', true);
            disconnect();
        },
        terminouDownloadPlanilhaAgricola() {
            this.ativarJanela = true;
            this.minimizarBloco = true;
            this.clearEmProcessamentoDownloadMonitoramentoAgricola();
            disconnect();
        },
        handleFecharModal() {
            let indexNaFilaDownload = this.encontrarIndexLista(this.steps.naFila, this.listaDownlod);
            let indexNaFilaUpload = this.encontrarIndexLista(this.steps.naFila, this.listaUpload);
            if (indexNaFilaDownload >= 0 || indexNaFilaUpload >= 0) {
                this.abrirModalCancelarTransferencias();
            } else {
                this.ativarJanela = false;
                this.minimizarBloco = false;
                this.listaDownlod = [];
                this.listaUpload = [];
                this.clearEmProcessamentoUploadLoteRenovabio();
                this.clearEmProcessamentoDownloadLoteRenovabio();
                this.clearEmProcessamentoDownloadMonitoramentoAgricola();
                this.clearUploadLoteRenovabioConcluido();
            }
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        formatDate(date) {
            return [
                this.padTo2Digits(date.getDate()),
                this.padTo2Digits(date.getMonth() + 1),
                date.getFullYear()
            ].join('/');
        },
        inserirDownloadNaLista(arquivo, codigo) {
            this.listaDownlod.push({
                step: this.steps.naFila,
                arquivo: arquivo,
                codigo: codigo
            });
        },
        inserirUploadNaLista(arquivo, codigo) {
            this.listaUpload.push({
                step: this.steps.naFila,
                arquivo: arquivo,
                codigo: codigo
            });
        },
        traduzirNomeArquivo(key, fallback) {
            try {
                const translated = this.$t(key);
                // If translation returns the key itself or empty, use fallback
                if (!translated || translated === key) {
                    return fallback;
                }
                return translated;
            } catch (e) {
                return fallback;
            }
        },
        formatDateForFilename(date) {
            // produce YYYYMMDD to keep filenames sortable and locale-independent
            const pad = (n) => n.toString().padStart(2, '0');
            return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
        },
        encontrarIndexLista(step, lista) {
            return lista.findIndex(value => value.step === step);
        }
    }
};
</script>
<style lang="scss" scoped>
.minimizar-enter-active,
.minimizar-leave-active {
    transition: opacity 0.5s ease;
}

.minimizar-enter-from,
.minimizar-leave-to {
    opacity: 0;
}
.wrapper {
    position: fixed;
    bottom: 0;
    right: 3px;
    z-index: 20000;
}

.bloco {
    position: absolute;
    right: 17px;
    bottom: 0px;
    background: var(--white);
    width: 400px;
    border-radius: 5px 5px 0px 0px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.blocos-ativos {
    right: 325px !important;
}
.bloco-head {
    width: inherit;
    height: 45px;
    background: var(--primary);
    padding: 8px;
    border-radius: 5px 5px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.bloco-head h2 {
    color: var(--white);
    display: inline-block;
    font-size: 14px;
}
.bloco-head .bloco-icon {
    color: var(--white);
    font-size: 24px;
    cursor: pointer;
}
.bloco-body {
    height: 260px;
    width: inherit;
    overflow: auto;
    margin-bottom: 30px;
}
.bloco-lista {
    .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: start;
    }
}
.bloco-lista ul {
    list-style: none;
    margin: 0;
    padding: 9px;
}
.bloco-lista ul li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    align-items: center;
    line-height: 17px;
    margin-bottom: 12px;
}
.bloco-lista ul li .mdi {
    font-size: 17px;
    color: #545454;
    cursor: pointer;
}
.bloco-lista ul li .mdi:hover {
    color: red;
}
.bloco-lista ul li span {
    font-size: 12px;
}
.bloco-footer {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    width: 400px;
    padding: 0px 4px 4px 4px;
}

.slide-enter-active {
    -moz-transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
    -moz-transition-timing-function: linear;
    -webkit-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
}

.slide-leave-active {
    -moz-transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
}

.slide-enter-to,
.slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

.corpo-mensagem {
    i {
        font-size: 35px;
        margin-bottom: 20px;
    }

    a.el-link {
        font-weight: bold;
        vertical-align: top !important;
    }

    padding: 60px 20px;
    text-align: center;
}

.corpo-mensagem-download {
    padding: 8px 16px;
    height: 40px;
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #FEFEFE;

    p {
        margin-bottom: 0;
        font-weight: 400 !important;
        font-size: 14px !important;
        color: #2C2C2C;
    }
}

.download {
    padding: 80px 20px 0px;
    text-align: center;
}

.el-message-box {
    width: 500px !important;
}

.el-message-box__btns {
    button {
        width: 100px !important;
    }

    .el-button--primary {
        background-color: var(--primary);
        border-color: var(--primary);
        color: var(--white);
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: var(--secondary);
        border-color: var(--secondary);
        color: var(--color-button-hover);
        outline: 0px auto var(--secondary);
    }
}

.icone::before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-block;
    background-color: var(--primary);
}

.icone-remover::before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-block;
    background-color: #C8312A;
    cursor: pointer;
}

.link-button {
    margin-right: 10px;
    color: #4294EC;
    font-weight: 500 !important;
    font-size: 14px !important;
}

.em-andamento {
    height: 32px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row;
    background-color: #E9E9E9;

    p {
        margin-bottom: 0;
    }
}

.download-lista {
    padding: 8px 16px;
    height: 32px;
    font-size: 14px;
    font-weight: 500;
}

.icone-status-sucesso {
    color: #359138 !important;
    font-size: 24px;
}

.icone-status-falha {
    color: #C8312A !important;
    font-size: 24px;
}

.icone-fechar {
    color: white !important;
    font-size: 24px;
    margin-left: 20px;
}

.lista-espera {
    font-size: 14px;
    font-weight: 400;
    color: #2C2C2C;
}

.nome-arquivo-download {
    margin: 0 22px;
    width: 260px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.nome-arquivo-upload {
    margin: 0 12px;
    width: 280px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
</style>
